export default __webpack_public_path__ + "static/media/1-icons-person-color.96645c4a.svg";